import React, { ReactElement } from "react";
import Grid from "@material-ui/core/Grid";

import {
  Container,
  Paper,
  Typography,
} from "@material-ui/core";
import { useStyles } from "./routergeraetStyles";
import { globalStyles } from "../../../assets/globalStyles";
import RoutergeraetGrid from "./grid";
import RoutergeraetEdit from "./edit";
import RoutergeraetActionheader from "./actionheader";


export default function Routergeraet(): ReactElement {

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };


  return (
    <React.Fragment>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Verwaltung Routergeräte
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <RoutergeraetEdit />
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
        <RoutergeraetActionheader />
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          <RoutergeraetGrid />
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
